import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'lineBreakTransform'
})
export class LineBreakTransformPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform(value: string, separator: string): string {
    if (!!value) {
      let sanitizedValue = this.domSanitizer.sanitize(SecurityContext.HTML, value);
      let lines: string[] = sanitizedValue.split(separator);
      let newValue: string = '';

      lines.forEach(x => {
        newValue += `${x} <br />`;
      });

      return newValue;
    } else {
      return '';
    }
  }
}
